import AssessmentScheduleDaily from "./AssessmentScheduleDaily"
import AssessmentScheduleMonthly from "./AssessmentScheduleMonthly"
import AssessmentScheduleSingle from "./AssessmentScheduleSingle"
import AssessmentScheduleWeekly from "./AssessmentScheduleWeekly"
import AssessmentScheduleYearly from "./AssessmentScheduleYearly"
import { getLocalTimeValue } from "./scheduleHelpers"

export default function AssessmentScheduleFormTypeSelector({
  type,
  time,
  timezone,
  disable,
  toggleRefreshCron,
}) {
  switch (type) {
    case "single":
      return (
        <AssessmentScheduleSingle
          cronFieldName={"cronSchedule"}
          timeValue={getLocalTimeValue(time, timezone).toJSDate()}
          refreshCronStatement={toggleRefreshCron}
        />
      )
    case "daily":
      return (
        <AssessmentScheduleDaily
          cronFieldName={"cronSchedule"}
          startDateFieldName={"startDate"}
          timeValue={getLocalTimeValue(time, timezone).toJSDate()}
          refreshCronStatement={toggleRefreshCron}
          disabled={disable}
        />
      )
    case "weekly":
    case "biweekly":
      return (
        <AssessmentScheduleWeekly
          cronFieldName={"cronSchedule"}
          timeValue={getLocalTimeValue(time, timezone).toJSDate()}
          refreshCronStatement={toggleRefreshCron}
          disabled={disable}
        />
      )
    case "monthly":
      return (
        <AssessmentScheduleMonthly
          cronFieldName={"cronSchedule"}
          timeValue={getLocalTimeValue(time, timezone).toJSDate()}
          refreshCronStatement={toggleRefreshCron}
          disabled={disable}
        />
      )
    case "yearly":
      return (
        <AssessmentScheduleYearly
          cronFieldName={"cronSchedule"}
          timeValue={getLocalTimeValue(time, timezone).toJSDate()}
          refreshCronStatement={toggleRefreshCron}
          disabled={disable}
        />
      )
    default:
      return <></>
  }
}
